import { useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { PORTFOLIO_STALE_TIME } from "@/api/portfolio-query";
import { client, useScopedMerchantClient } from "../scoped-merchant-client";

export const useAssuranceOverview = () => {
  const scope = useScopedMerchantClient();

  return useQuery({
    queryKey: ["assurance-overview", scope.merchantId, scope.workspaceId],
    queryFn: async () => {
      const res = scope.workspaceId
        ? await client.workspace[":workspaceId"].merchant[":merchantId"].assurance.metrics.overview.$get({
            param: scope.param,
          })
        : await client.merchant[":merchantId"].assurance.metrics.overview.$get({
            param: scope.param,
          });

      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    enabled: !!scope.merchantId,
  });
};

export type AssuranceOverviewV2DateRange = { startDate?: string; endDate?: string };

export const useAssuranceOverviewV2 = (dateRange?: AssuranceOverviewV2DateRange) => {
  const scope = useScopedMerchantClient();

  return useQuery({
    queryKey: ["assurance-overview-v2", scope.merchantId, scope.workspaceId, dateRange],
    queryFn: async () => {
      const query = { startDate: dateRange?.startDate, endDate: dateRange?.endDate };
      const res = scope.workspaceId
        ? await client.workspace[":workspaceId"].merchant[":merchantId"].assurance.metrics["overview-v2"].$get({
            param: scope.param,
            query,
          })
        : await client.merchant[":merchantId"].assurance.metrics["overview-v2"].$get({
            param: scope.param,
            query,
          });

      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    enabled: !!scope.merchantId,
  });
};

export const usePortfolioAssuranceOverview = (workspaceId?: string) => {
  return useQuery({
    queryKey: ["portfolio-assurance-overview", workspaceId ?? null],
    queryFn: async () => {
      const res = workspaceId
        ? await client.workspace[":workspaceId"].portfolio["assurance-overview"].$get({
            param: { workspaceId },
            query: {},
          })
        : await client.portfolio["assurance-overview"].$get({ query: {} });

      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    staleTime: PORTFOLIO_STALE_TIME,
  });
};
